import { ChangePasswordEffects } from './change-password.effects';

export const homeEffects = [ChangePasswordEffects];
